"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const appSlice_1 = require("../store/slices/appSlice");
const Logo_1 = __importDefault(require("../components/Logo"));
const store_1 = require("../store/store");
const Header = ({ pages, location, children }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { sidebarOpen } = (0, store_1.useAppSelector)((state) => state.app);
    const toggleSidebar = () => {
        dispatch((0, appSlice_1.setSidebarOpen)(!sidebarOpen));
    };
    const currentPage = (0, react_1.useMemo)(() => _.find(pages, (page) => (page === null || page === void 0 ? void 0 : page.url) === location.pathname), [pages, location.pathname]);
    const showLogo = [
        '/',
        '/auth/login',
        '/auth/register',
        '/auth/reset-password',
        '/auth/login/step-2',
    ].includes((currentPage === null || currentPage === void 0 ? void 0 : currentPage.url) || '');
    (0, react_1.useEffect)(() => {
        addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && sidebarOpen) {
                dispatch((0, appSlice_1.setSidebarOpen)(false));
            }
        });
        return () => {
            removeEventListener('keydown', () => { });
        };
    }, [dispatch, sidebarOpen]);
    return ((0, jsx_runtime_1.jsxs)("header", { className: `main-header ${(currentPage === null || currentPage === void 0 ? void 0 : currentPage.url) === '/' ? 'mobile-header-home' : ''}`, children: [(0, jsx_runtime_1.jsxs)("button", { id: "mobile-menu-trigger", className: (0, classnames_1.default)('mobile-menu-trigger', { open: sidebarOpen }), onClick: toggleSidebar, "aria-label": __.trans(sidebarOpen ? 'sidebar.close-sidebar' : 'sidebar.open-sidebar'), children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {})] }), (0, jsx_runtime_1.jsx)("div", { className: "title-container", children: showLogo ? (0, jsx_runtime_1.jsx)(Logo_1.default, {}) : (0, jsx_runtime_1.jsx)("span", { children: currentPage === null || currentPage === void 0 ? void 0 : currentPage.menuTitle }) }), children] }));
};
exports.default = Header;
